import styled from 'styled-components';

export const Form = styled.form`
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 0px 5px 0px gray;
`;
export const TextInput = styled.input`
  flex: 1;
  padding: 0.2rem;
  margin-left: 10px;
  margin-right: 10px;
  border: 1px solid gray;
  border-radius: 1rem;
  text-align: center;
`;
export const Button = styled.button`
  width: 34px;
  height: 34px;
  border-radius: 17px;
  text-align: center;
  background-color: #2ec1ac;
  color: white;
  margin-right: 10px;
`;
